export default __webpack_public_path__ + "static/mn-2ccb071c2a5f6f6b1dc2933a5e7b5cab.svg";